export default function Footer() {
  const sitemapLinks = [
    { label: 'ホーム', href: '#home' },
    { label: '協会について', href: '#about' },
    { label: '事業内容', href: '#business' },
    { label: 'サービス＆プログラム', href: '#services' },
    { label: 'ペット×ウェルビーイング', href: '#pet' },
    { label: 'LED光美容 WellTerra', href: '#wellterra' },
    { label: 'お知らせ', href: '#news' },
    { label: 'お問い合わせ', href: '#contact' },
  ];

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-[#1A2B3C] text-[#B0C4D8] pt-20 pb-10">
      <div className="max-w-[1200px] mx-auto px-10">
        {/* 上部エリア */}
        <div className="grid md:grid-cols-3 gap-16 mb-16">
          {/* 左カラム：協会情報 */}
          <div>
            <img
              src="https://static.readdy.ai/image/69410fb2e6bcdd872737f1aa8d7dee35/baf478bf3cc0ca3183d92ef9021d5d79.jpeg"
              alt="未来ウェルビーイング協会"
              className="h-10 w-auto mb-6 brightness-0 invert"
            />
            <h3 className="text-base text-white font-semibold mb-2">
              一般社団法人 未来ウェルビーイング協会
            </h3>
            <p className="text-[13px] mb-8">Future Well-Being Association</p>
            <address className="text-sm leading-relaxed not-italic mb-4">
              〒542-0083<br />
              大阪府大阪市中央区東心斎橋1丁目7-30<br />
              21心斎橋ビル 3F
            </address>
            <a
              href="mailto:info@future-wellbeing.or.jp"
              className="text-sm hover:text-white transition-colors duration-300 underline block mb-2"
            >
              info@future-wellbeing.or.jp
            </a>
            <a
              href="tel:06-1234-5678"
              className="text-sm hover:text-white transition-colors duration-300"
            >
              TEL: 06-1234-5678
            </a>
          </div>

          {/* 中央カラム：サイトマップ */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-6 tracking-wider">SITEMAP</h3>
            <nav className="space-y-3">
              {sitemapLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="block text-sm hover:text-[#50C9C3] hover:translate-x-1 transition-all duration-300 cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>

          {/* 右カラム：SNS */}
          <div>
            <h3 className="text-sm font-semibold text-white mb-6 tracking-wider">FOLLOW US</h3>
            <div className="flex gap-4">
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-gradient-to-r hover:from-[#4A90E2] hover:to-[#50C9C3] hover:rotate-12 transition-all duration-300 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-gradient-to-r hover:from-[#4A90E2] hover:to-[#50C9C3] hover:rotate-12 transition-all duration-300 cursor-pointer"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-gradient-to-r hover:from-[#4A90E2] hover:to-[#50C9C3] hover:rotate-12 transition-all duration-300 cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="#"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-gradient-to-r hover:from-[#4A90E2] hover:to-[#50C9C3] hover:rotate-12 transition-all duration-300 cursor-pointer"
                aria-label="LINE"
              >
                <i className="ri-line-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        {/* 下部エリア */}
        <div className="pt-10 border-t border-white/10">
          {/* ポリシーリンク */}
          <div className="flex flex-wrap justify-center gap-6 mb-4">
            <a
              href="#"
              className="text-[13px] hover:text-[#50C9C3] transition-colors duration-300 underline cursor-pointer"
            >
              プライバシーポリシー
            </a>
            <a
              href="#"
              className="text-[13px] hover:text-[#50C9C3] transition-colors duration-300 underline cursor-pointer"
            >
              特定商取引法に基づく表記
            </a>
          </div>

          {/* コピーライト */}
          <p className="text-xs text-center text-[#6A7C8E]">
            © 2025 Future Well-Being Association. All Rights Reserved.
            {' | '}
            <a
              href="https://readdy.ai/?origin=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-[#50C9C3] transition-colors duration-300"
            >
              Website Builder
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
